import { render } from "./ResultEmptySupport.vue?vue&type=template&id=2678d217&scoped=true"
import script from "./ResultEmptySupport.vue?vue&type=script&lang=js"
export * from "./ResultEmptySupport.vue?vue&type=script&lang=js"

import "./ResultEmptySupport.vue?vue&type=style&index=0&id=2678d217&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/app.lensmark.kz/mini-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2678d217"]])

export default __exports__